import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";

export default function PageHero({
  eyebrow,
  title,
  highlight,
  description,
  ctaText,
  ctaTo,
  testId = "page-hero",
}) {
  return (
    <section
      data-testid={testId}
      className="brand-hero relative overflow-hidden pt-20 pb-16 sm:pt-28 sm:pb-24"
    >
      <div aria-hidden="true" className="brand-hero-grid absolute inset-0" />

      <div className="relative max-w-5xl mx-auto px-5 sm:px-8 text-center">
        {eyebrow && (
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full brand-hero-badge border text-xs font-semibold tracking-[0.18em] uppercase text-white mb-6">
            <span className="h-1.5 w-1.5 rounded-full bg-orange-300" />
            {eyebrow}
          </div>
        )}

        <h1 className="font-heading font-black text-white text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.05] mb-5">
          {title}{" "}
          {highlight && (
            <span className="brand-hero-highlight">{highlight}</span>
          )}
        </h1>

        {description && (
          <p className="text-base sm:text-lg text-white/85 max-w-2xl mx-auto leading-relaxed">
            {description}
          </p>
        )}

        {ctaText && ctaTo && (
          <Link
            to={ctaTo}
            data-testid={`${testId}-cta`}
            className="mt-9 inline-flex items-center gap-2 px-6 py-3 rounded-full brand-hero-primary text-sm font-bold transition-colors btn-shimmer"
          >
            {ctaText}
            <ArrowRight size={16} weight="bold" />
          </Link>
        )}
      </div>
    </section>
  );
}
